export default "__VITE_ASSET__xbMzBmzr__"